import { render } from "./CopyJsonTd.vue?vue&type=template&id=1aa7d656"
import script from "./CopyJsonTd.vue?vue&type=script&lang=js"
export * from "./CopyJsonTd.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__